export default __webpack_public_path__ + "empty-activity-md.8e592259.svg";